import { Maximize2, Minimize2 } from 'lucide-react';
import type { ReactElement } from 'react';
import type { FlatFitMode } from '@/features/design-editor';

interface FitModeToggleProps {
  readonly mode: FlatFitMode;
  readonly onChange: (mode: FlatFitMode) => void;
}

/**
 * 캔버스 오른쪽 위의 보기 토글 — 전체 보기(기본)와 영역 확대(휠로 확대·축소, 빈 곳 끌어 이동)를 오간다.
 * 버튼 이름은 "누르면 무엇이 되는지"다. 캔버스 안내 줄과 같은 작은 흰 칸 결.
 */
export const FitModeToggle = ({ mode, onChange }: FitModeToggleProps): ReactElement => {
  const toPhoto = mode === 'area';
  const Icon = toPhoto ? Maximize2 : Minimize2;
  const label = toPhoto ? '전체 보기' : '영역 확대';

  return (
    <button
      type="button"
      aria-pressed={!toPhoto}
      title={
        toPhoto
          ? '인쇄 영역을 크게 보고 휠·끌기로 자유롭게 움직여요'
          : '사진 전체가 보이게 되돌려요'
      }
      onClick={() => onChange(toPhoto ? 'photo' : 'area')}
      className="absolute top-2 right-2 inline-flex h-8 cursor-pointer items-center gap-1.5 bg-background/90 px-2.5 text-xs font-medium text-foreground shadow-sm transition-colors hover:bg-foreground hover:text-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Icon aria-hidden className="size-3.5" strokeWidth={1.75} />
      {label}
    </button>
  );
};
